module.exports = __webpack_public_path__ + "static/img/headImg.54e96a8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/headImg.jpg
// module id = XWbq
// module chunks = 1